// Admin Authentication Pages translations
export const adminAuthTranslations = {
    en: {
        // Common
        email: "Email",
        password: "Password",
        confirmPassword: "Confirm Password",
        signIn: "Sign In",
        signUp: "Sign Up",
        register: "Register",
        loading: "Loading...",
        signingIn: "Signing In...",
        required: "*",

        // Login Page
        adminLogin: "Admin Login",
        welcomeBack: "Welcome Back",
        loginToYourStore: "Sign in to your store dashboard",
        emailAddress: "Email Address",
        enterYourEmail: "Enter your email",
        enterYourPassword: "Enter your password",
        forgotPassword: "Forgot your password?",
        continueWithGoogle: "Continue with Google",
        or: "OR",
        dontHaveAccount: "Don't have an account?",
        createStore: "Create your store",

        // Registration Page  
        createYourStore: "Create Your Store",
        setupStoreSteps: "Set up your online store in just 2 simple steps",
        accountDetails: "Account Details",
        storeInfo: "Store Info",
        ownerName: "Owner Name",
        enterYourName: "Enter your full name",
        minimumCharacters: "Minimum 6 characters",
        confirmPasswordPlaceholder: "Confirm password",
        continueWithGoogleRegister: "Continue with Google",
        storeName: "Store Name",
        enterStoreName: "Enter your store name",
        storeDescription: "Store Description (Optional)",
        storeDescriptionPlaceholder: "Brief description of your store and what you sell...",
        storeAddress: "Store Address (Optional)",
        enterStoreAddress: "Enter your store address",
        createStoreWithGoogle: "Create Store with Google",
        creatingStoreWithGoogle: "Creating Store with Google...",
        createMyStore: "Create My Store",
        creatingYourStore: "Creating Your Store...",
        alreadyHaveAccount: "Already have an account?",

        // Success Modal
        congratulations: "Congratulations!",
        storeCreatedSuccessfully: "Your store has been created successfully!",
        goToLogin: "Go to Login",

        // Reset Password
        resetPassword: "Reset Password",
        enterEmailForReset: "Enter your email address and we'll send you a link to reset your password.",
        sendResetLink: "Send Reset Link",
        sending: "Sending...",
        backToSignIn: "Back to Sign In",
        resetEmailSent: "Reset email sent successfully!",
        checkYourEmailForReset: "Check your email for password reset instructions.",

        // Error Messages
        pleaseEnterBothEmailAndPassword: "Please enter both email and password",
        pleaseEnterValidEmail: "Please enter a valid email address",
        emailIsRequired: "Email is required",
        passwordIsRequired: "Password is required",
        ownerNameIsRequired: "Owner name is required",
        storeNameIsRequired: "Store name is required",
        passwordsDoNotMatch: "Passwords do not match",

        // Navigation
        previous: "Previous",
        next: "Next"
    },
    ar: {
        // Common
        email: "البريد الإلكتروني",
        password: "كلمة المرور",
        confirmPassword: "تأكيد كلمة المرور",
        signIn: "تسجيل الدخول",
        signUp: "التسجيل",
        register: "إنشاء حساب",
        loading: "جارٍ التحميل...",
        signingIn: "جارٍ تسجيل الدخول...",
        required: "*",

        // Login Page
        adminLogin: "دخول الإدارة",
        welcomeBack: "أهلاً بعودتك",
        loginToYourStore: "سجل الدخول إلى لوحة تحكم متجرك",
        emailAddress: "عنوان البريد الإلكتروني",
        enterYourEmail: "أدخل بريدك الإلكتروني",
        enterYourPassword: "أدخل كلمة المرور",
        forgotPassword: "نسيت كلمة المرور؟",
        continueWithGoogle: "المتابعة مع جوجل",
        or: "أو",
        dontHaveAccount: "ليس لديك حساب؟",
        createStore: "أنشئ متجرك",

        // Registration Page
        createYourStore: "أنشئ متجرك",
        setupStoreSteps: "قم بإنشاء متجرك الإلكتروني في خطوتين بسيطتين فقط",
        accountDetails: "تفاصيل الحساب",
        storeInfo: "معلومات المتجر",
        ownerName: "اسم المالك",
        enterYourName: "أدخل اسمك الكامل",
        minimumCharacters: "6 أحرف كحد أدنى",
        confirmPasswordPlaceholder: "تأكيد كلمة المرور",
        continueWithGoogleRegister: "المتابعة مع جوجل",
        storeName: "اسم المتجر",
        enterStoreName: "أدخل اسم متجرك",
        storeDescription: "وصف المتجر (اختياري)",
        storeDescriptionPlaceholder: "وصف مختصر لمتجرك وما تبيعه...",
        storeAddress: "عنوان المتجر (اختياري)",
        enterStoreAddress: "أدخل عنوان متجرك",
        createStoreWithGoogle: "أنشئ المتجر مع جوجل",
        creatingStoreWithGoogle: "جارٍ إنشاء المتجر مع جوجل...",
        createMyStore: "أنشئ متجري",
        creatingYourStore: "جارٍ إنشاء متجرك...",
        alreadyHaveAccount: "لديك حساب بالفعل؟",

        // Success Modal
        congratulations: "مبروك!",
        storeCreatedSuccessfully: "تم إنشاء متجرك بنجاح!",
        goToLogin: "الذهاب إلى تسجيل الدخول",

        // Reset Password
        resetPassword: "إعادة تعيين كلمة المرور",
        enterEmailForReset: "أدخل عنوان بريدك الإلكتروني وسنرسل لك رابطاً لإعادة تعيين كلمة المرور.",
        sendResetLink: "إرسال رابط الإعادة",
        sending: "جارٍ الإرسال...",
        backToSignIn: "العودة إلى تسجيل الدخول",
        resetEmailSent: "تم إرسال بريد إعادة التعيين بنجاح!",
        checkYourEmailForReset: "تحقق من بريدك الإلكتروني للحصول على تعليمات إعادة تعيين كلمة المرور.",

        // Error Messages
        pleaseEnterBothEmailAndPassword: "يرجى إدخال البريد الإلكتروني وكلمة المرور",
        pleaseEnterValidEmail: "يرجى إدخال عنوان بريد إلكتروني صالح",
        emailIsRequired: "البريد الإلكتروني مطلوب",
        passwordIsRequired: "كلمة المرور مطلوبة",
        ownerNameIsRequired: "اسم المالك مطلوب",
        storeNameIsRequired: "اسم المتجر مطلوب",
        passwordsDoNotMatch: "كلمات المرور غير متطابقة",

        // Navigation
        previous: "السابق",
        next: "التالي"
    }
};

// Translation hook for admin auth
export const useAdminAuthTranslation = (language = 'en') => {
    const t = (key, replacements = {}) => {
        let translation = adminAuthTranslations[language]?.[key] || adminAuthTranslations['en'][key] || key;

        // Handle string replacements like {message}
        Object.keys(replacements).forEach(placeholder => {
            translation = translation.replace(new RegExp(`{${placeholder}}`, 'g'), replacements[placeholder]);
        });

        return translation;
    };

    return { t };
};